import Address          from "../fundamentals/address/Address";
import Trail            from "../fundamentals/trail/Trail";
import CustomerBirthday from "./CustomerBirthday";
import CustomerContact  from "./CustomerContact";
import CustomerDetail   from "./CustomerDetail";
import CustomerId       from "./CustomerId";

class Customer {
  constructor(
    private readonly _id: CustomerId = new CustomerId(),
    private readonly _detail: CustomerDetail = new CustomerDetail(),
    private readonly _birthday: CustomerBirthday = new CustomerBirthday(),
    private readonly _contact: CustomerContact = new CustomerContact(),
    private readonly _address: Address = new Address(),
    private readonly _trail: Trail = new Trail(),
  ) {
  }

  public isEmpty(): boolean {
    return isNaN(this._id.value);
  }

  get id() {
    return this._id;
  }

  get detail() {
    return this._detail;
  }

  get birthday() {
    return this._birthday;
  }

  get contact() {
    return this._contact;
  }

  get address() {
    return this._address;
  }

  get trail() {
    return this._trail;
  }
}

export default Customer;
